export default "__VITE_ASSET__5gPSIsmO__"